const Main = ({ component: Component, ...rest }) => (
	<div className="app-content">
		<Component {...rest} />
		{/* <div style={{fontSize: 8}}><span>{'Environment: ' + process.env.NODE_ENV}</span></div> */}
	</div>
);

export default Main;
